var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.imagenes.length > 0,
            expression: "imagenes.length > 0"
          }
        ],
        staticClass: "row"
      },
      [
        _vm._m(1),
        _vm._v(" "),
        _vm._l(_vm.imagenes, function(imagen) {
          return _c(
            "div",
            { key: imagen.id, staticClass: "col-xs-12 col-md-4" },
            [
              _c(
                "a",
                { attrs: { href: imagen.url_archivo, target: "_blank" } },
                [
                  _c("img", {
                    attrs: {
                      src: imagen.url_archivo,
                      width: "100%",
                      alt: imagen.url_archivo
                    }
                  })
                ]
              )
            ]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.videos.length > 0,
            expression: "videos.length > 0"
          }
        ],
        staticClass: "row"
      },
      [
        _vm._m(2),
        _vm._v(" "),
        _vm._l(_vm.videos, function(video) {
          return _c(
            "div",
            { key: video.id, staticClass: "col-xs-12 col-md-4" },
            [
              _c("video", {
                staticStyle: { width: "100%" },
                attrs: { src: video.url_archivo, controls: "" }
              })
            ]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.audios.length > 0,
            expression: "audios.length > 0"
          }
        ],
        staticClass: "row"
      },
      [
        _vm._m(3),
        _vm._v(" "),
        _vm._l(_vm.audios, function(audio) {
          return _c(
            "div",
            { key: audio.id, staticClass: "col-xs-12 col-md-4" },
            [
              _c("audio", { attrs: { controls: "" } }, [
                _c("source", {
                  attrs: { src: audio.url_archivo, type: "audio/mp4" }
                })
              ])
            ]
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn-danger btn--text",
          on: {
            click: function($event) {
              return _vm.$emit("cerrar")
            }
          }
        },
        [_c("i", { staticClass: "fa fa-ban" }), _c("span", [_vm._v("Cerrar")])]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Galería de medios")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("h5", [_vm._v("Imágenes")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("h5", [_vm._v("Videos")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("h5", [_vm._v("Audios")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c240280", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c240280","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/consultas/GaleriaMedios.vue
// module id = 582
// module chunks = 0